// extracted by mini-css-extract-plugin
export default {"products-container":"Dashboard_products-container__lSDZd"};